<template>
  <b-overlay :show="isLoading">
    <SelectComponent
        :options="scales | idNameToValueLabel"
        :disabled="disabled"
        :searching="isLoading"
        @search="autocomplete"
        @input="evt => $emit('input', evt)">
      <template v-slot:no-results>
        {{ $t('components.select.nenhum_resultado') }}:<br/>
        "{{ stringSearch }}"<br/>
        {{ $t('components.select.deseja_incluir') }}<br/>
        <b-button variant="success" size="sm" class="ml-2" pill @click="addNew">
          {{ $t('components.select.sim') }}
        </b-button>
      </template>
    </SelectComponent>
  </b-overlay>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import ScaleRepository from '@/repositories/tuevs/ScaleRepository';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SelectTuevsEscala",
  components: {SelectComponent},
  props: {
    model: null,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'tuevs/scale/isLoading',
      scales: 'tuevs/scale/all',
    })
  },
  data() {
    return {
      stringSearch: '',
      awaitingSearch: false
    }
  },
  methods: {
    ...mapActions([
      'tuevs/scale/search',
    ]),
    async autocomplete(string) {
      this.stringSearch = string
      if (string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this['tuevs/scale/search']({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    },
    async addNew() {
      ScaleRepository.post({
        code: this.stringSearch,
        name: this.stringSearch,
        status: 1
      }).then(() => {
        this.$snotify.success(this.$t('tuevs.scale.form.create.success'))
        this.autocomplete(this.stringSearch)
      }).catch(() => {
        this.$snotify.error(this.$t('tuevs.scale.form.create.error'))
      })
    },
  },
  mounted() {
    this['tuevs/scale/search']()
  }
}
</script>

<style lang="scss" scoped>
</style>